import styled from 'styled-components';

export const StyledYearFilter = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.COLORS.LIGHT_SILVER};
  padding: 18px 0;
  display: flex;
  flex-direction: column;
`;

export const StyledFilterHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
`;
